import { SliderWrapper } from '@/components/shared/SliderWrapper';
import { SkeletonChild, SkeletonParent } from '@/components/ui/Skeleton/skeleton';

export const GmDailyRewardsSkeleton = () => {
  return (
    <SkeletonParent className="flex flex-col rounded-2xl">
      <div className="p-4">

        <SkeletonChild className="rounded-lg  h-5 w-29.5 self-start" />
      </div>

      <div className="relative w-full overflow-x-clip">
        <SliderWrapper>
          <div className="flex w-max md:w-full grow flex-1 px-4">
            <div className="w-fit xxl:w-full flex gap-2.5">
              {
                Array.from({ length: 10 }).map(
                  (_, i) => (
                    <SkeletonParent key={i} className="min-w-22.5 xxl:flex grow md:min-w-25 shrink-0">
                      <SkeletonChild className="md:w-25 xxl:w-full w-full px-3 pt-4.5 h-35.5 flex justify-between flex-col rounded-2xl gap-[0.813rem]">
                        <SkeletonChild className="rounded-full block mx-auto size-16 shrink-0" />
                        <SkeletonChild className="h-4 w-full block rounded-lg mb-[0.438rem]" />
                      </SkeletonChild>
                    </SkeletonParent>
                  ),
                )
              }
            </div>
          </div>
        </SliderWrapper>
      </div>

      <div className="p-4 w-full">
        <SkeletonChild className="h-4 self-center rounded-lg mx-auto max-w-[19.938rem] w-full" />
      </div>
    </SkeletonParent>
  );
};
